import React from 'react';
import { Box, Typography, Divider } from '@material-ui/core';

const QR_LEGEND = [
  { label: '0',    color: '#FFFFFF' },
  { label: '0.1',  color: '#E1F5FE' },
  { label: '50',   color: '#81D4FA' },
  { label: '150',  color: '#29B6F6' },
  { label: '350',  color: '#1976D2' },
  { label: '550',  color: '#5E35B1' },
  { label: '750',  color: '#8E24AA' },
  { label: '1000', color: '#C2185B' },
  { label: '1250', color: '#E53935' },
  { label: '1500', color: '#F4511E' },
  { label: '1800', color: '#E64A19' },
  { label: '2100', color: '#D32F2F' },
  { label: '2400', color: '#B71C1C' },
  { label: '2700', color: '#7F0000' },
  { label: '4000', color: '#7F0000' },
];

const QR_STATUS_LEGEND = [
  { label: 'ปกติ', color: '#14875D' },
  { label: 'เฝ้าระวัง', color: '#E5A31B' },
  { label: 'เตือนภัย', color: '#ED9B4D' },
  { label: 'วิกฤต', color: '#C83C35' },
];

export default function RRIColorScaleLegend() {
  return (
    <Box style={{ marginTop: 8 }}>
      {/* <Typography style={{ fontFamily: 'Noto Sans Thai', fontSize: 13, fontWeight: 700, color: '#172B3D' }}>
        ปริมาณน้ำท่าคาดการณ์
      </Typography>
      <Typography style={{ fontFamily: 'Noto Sans Thai', fontSize: 10, color: '#7E8F9F', marginBottom: 10 }}>
        ลูกบาศก์เมตร/วินาที
      </Typography> */}

      {/* Color Bar */}
      {/* <Box style={{ display: 'flex', width: '100%', height: 12, borderRadius: 6, overflow: 'hidden', border: '1px solid #D9E5EE' }}>
        {QR_LEGEND.map(({ color }) => (
          <Box key={color} style={{ flex: 1, backgroundColor: color }} />
        ))}
      </Box> */}

      {/* Labels */}
      {/* <Box style={{ display: 'flex', justifyContent: 'space-between', marginTop: 4 }}>
        {QR_LEGEND.filter((_, i) => i % 2 === 0).map(({ label }) => (
          <Typography key={label} style={{ fontFamily: 'Noto Sans Thai', fontSize: 9, color: '#7E8F9F' }}>
            {label}
          </Typography>
        ))}
      </Box> */}

        {/* <Divider
            style={{
                marginTop:10,
                marginRight:5,
                backgroundColor: '#DBE5EC',
                height: 1,
            }}
        />  */}

        <Box
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
                marginTop: 10,
                marginRight: 5,
            }}
        >
            {QR_STATUS_LEGEND.map(({ label, color }) => (
                <Box
                key={label}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 4,
                    marginRight: 10,
                }}
                >
                <Box
                    style={{
                    width: 8,
                    height: 8,
                    borderRadius: '50%',
                    backgroundColor: color,
                    flexShrink: 0,
                    }}
                />

                <Typography
                    style={{
                    fontFamily: 'Noto Sans Thai',
                    fontSize: 9,
                    color: '#070707',
                    whiteSpace: 'nowrap',
                    }}
                >
                    {label}
                </Typography>
                </Box>
            ))}
        </Box>
    </Box>
  );
}